import React from 'react';
import PropTypes from 'prop-types';
import Row from 'kepler/lib/components/Row';
import Col from 'kepler/lib/components/Col';
import Button from 'kepler/lib/components/Button';
import getContent from '../lib/dictionaryFetcher';

const AppDetailContentTop = props => {
  const { partner, onClick, isDesktop } = props;

  const marketplace = getContent(
      'merchanthub',
      `apps.${partner}.marketplace`,
      ''
    ),
    title = getContent('merchanthub', `apps.${partner}.title`, ''),
    shortDescription = getContent(
      'merchanthub',
      `apps.${partner}.shortDescription`,
      ''
    ),
    getStarted = getContent('merchanthub', `apps.${partner}.getStarted`, '');

  return (
    <Row>
      <Col style={{ width: isDesktop ? '33%' : '40%' }}>
        <div className={`app-image ${partner}-image`} />
      </Col>
      <Col style={{ width: isDesktop ? '36%' : '60%' }}>
        <div className="marketplace-type">{marketplace}</div>
        <div className="marketplace-title">{title}</div>
        <div className="marketplace-short-description">{shortDescription}</div>
      </Col>
      <Col
        className="get-started-button-title-container"
        style={{ width: isDesktop ? '31%' : '100%' }}
      >
        <Button onClick={onClick} className="get-started-button">
          {getStarted}
        </Button>
      </Col>
    </Row>
  );
};

AppDetailContentTop.propTypes = {
  partner: PropTypes.string,
  onClick: PropTypes.func,
  isDesktop: PropTypes.bool
};

export default AppDetailContentTop;
